<template>
    <div>
        <button v-if="loader" type="button" class="button button-loader"></button>
        <button v-else @click="send" :disabled="event.user.is_friend.type != 3" class="button">
            {{ $t("albums.add") }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'EventFriendButton',

    props: {
        event: {
            type: Object,
            required: true
        },
        i18n: Object
    },
    data() {
        return {
            loader: false
        }
    },
    methods: {
        send() {
            this.loader = true;
            this.$store.dispatch('friendsIncoming/accept', this.event.user.id)
                .then(() => {
                    this.$modal.show('dialog', {
                        title: this.$t("myFriends.success"),
                        text: this.$t("events.friendSuccessfullyAdded"),
                        buttons: [
                            {
                                title: this.$t("mixins.ok"),
                            }
                        ]
                    });
                    this.$store.dispatch('events/setFriendAccepted', this.event.user.id)
                    this.loader = false;
                })
                .catch(() => {
                    this.loader = false;
                });
        }
    }
}
</script>
